exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Stats-a659de04{background:#f5f5f5;padding:20px 0 20px 0}\n", ""]);

// Exports
exports.locals = {
	"Stats": "Stats-a659de04"
};